import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_client_risklevel_add_edit-${key}`)
